mutation RequestImageEditUploadUrl($input: RequestImageEditUploadUrlInput!) {
  requestImageEditUploadUrl(input: $input) {
    uploadUrl
    s3Key
    expiresAt
  }
}
